import { functions } from "../firebase";

export type GoogleCalendarConnection = {
  connected: boolean;
  email?: string;
  scopes?: string[];
  stale?: boolean;
  staleReason?: string | null;
};

export const getGoogleCalendarConnection = async (
  communityId: string
): Promise<GoogleCalendarConnection> => {
  const callable = functions.httpsCallable("googleCalendarGetConnection");
  const result = await callable({ communityId });
  return result.data as GoogleCalendarConnection;
};

export const startGoogleCalendarAuth = async (
  communityId: string
): Promise<{ url: string; expiresAt: string }> => {
  const callable = functions.httpsCallable("googleCalendarStartAuth");
  const result = await callable({ communityId });
  return result.data as { url: string; expiresAt: string };
};

export const disconnectGoogleCalendar = async (
  communityId: string
): Promise<{ connected: boolean }> => {
  const callable = functions.httpsCallable("googleCalendarDisconnect");
  const result = await callable({ communityId });
  return result.data as { connected: boolean };
};
